export default {
  cards: {
    chart: {
      profilLulusan: {
        queryName: "profil_lulusan",
        content: {
          title: "Jumlah Lulusan per Tahun",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik tren profil lulusan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 892,
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["Laki-laki", "Perempuan"],
            },
            xAxis: {
              type: "category",
              data: [],
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: "Laki-laki",
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
              {
                name: "Perempuan",
                type: "bar",
                itemStyle: {
                  color: "#389BF6",
                },
              },
            ],
          },
          columns: [
            {
              title: "Tahun",
              dataIndex: "tahun",
            },
            {
              title: "Jumlah Profil Lulusan Perempuan",
              dataIndex: "perempuan",
            },
            {
              title: "Jumlah Profil Lulusan Laki-Laki",
              dataIndex: "laki2",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      tendikGender: {
        queryName: "jumlah_tendik_by_jeniskelamin",
        content: {
          title: "Statistik Jumlah Tendik",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik jumlah tendik menurut jenis kelamin",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            backgroundColor: "#389BF6",
            titleColor: "white",
            height: 440,
          },
          chartOption: {
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                name: "Jumlah Tenaga Kependidikan Guru/Dosen",
                type: "pie",
                label: {
                  formatter: "{b} ({d}%)",
                  color: "white",
                },
                radius: "75%",
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
                itemStyle: {
                  normal: {
                    color: (params) => {
                      const colorList = ["#1B6FBD", "#5FB2FF"];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          columns: [
            {
              title: "Jumlah Tendik Perempuan",
              dataIndex: "perempuan",
            },
            {
              title: "Jumlah Tendik Laki-Laki",
              dataIndex: "laki",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      tendikLulusan: {
        queryName: "jumlah_tendik_by_jenjangpendidikan",
        content: {
          title: "Jumlah Dosen/Guru per Latar Pendidikan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik tenaga kependidikan berdasarkan jenjang pendidikan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 440,
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["Laki-laki", "Perempuan"],
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return (
                    value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
                  );
                },
              },
            },
            series: [
              {
                name: "Laki-laki",
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
              {
                name: "Perempuan",
                type: "bar",
                itemStyle: {
                  color: "#389BF6",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jenjang Pendidikan",
              dataIndex: "pendidikan",
            },
            {
              title: "Jumlah Profil Lulusan Perempuan",
              dataIndex: "perempuan",
            },
            {
              title: "Jumlah Profil Lulusan Laki-Laki",
              dataIndex: "laki2",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
